import { createApp } from 'vue'
import ShopsBlock from '../components/ShopsBlock.vue'

const el = document.getElementById('shops-vue');

if (el) {
    const app = createApp({});

    app.component('ShopsBlock', ShopsBlock);

    app.mount(el);
}
